module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "part"
    }
  }, [_vm._v("“But as you already know your rights and privileges so well, I am going to ask you to excuse me if I say a few words to you about your duties. Much has been given to us … and we must take heed to use aright the gifts entrusted to our care. It is not what we have that will make us a great nation; it is the way in which we use it. I do not undervalue for a moment our material prosperity; like all Americans, I like big things; big prairies, big forests and mountains, big wheat fields, railroads … big factories, steamboats, and everything else. But we must keep steadfastly in mind that no people were ever yet benefited by riches if their prosperity corrupted their virtue.”")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ind"
  }, [_vm._v("July 4, 1886:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hon. Theodore Roosevelt,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("addressing the first")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Independence Day celebration")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("in Dickinson,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dakota Territory")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5f1b27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6part.vue
// module id = 78
// module chunks = 0